import { Check, Clock, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FORMULES } from "@/lib/api";

export default function Pricing({ onBookFormule }) {
  return (
    <section
      id="prestations"
      data-testid="pricing-section"
      className="bg-white py-20 lg:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <p className="text-sm uppercase tracking-[0.18em] text-[#1E88C8] font-semibold">
            Prestations
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#0B3A5B] mt-3">
            Trois formules, pour chaque besoin.
          </h2>
          <p className="mt-4 text-base text-[#2F3438]/75 leading-relaxed">
            De l&apos;entretien régulier à la remise à neuf complète, choisissez la formule
            adaptée à votre véhicule. Le devis détaillé est confirmé par téléphone lors de la prise de rendez-vous.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {FORMULES.map((f, idx) => {
            const isAccent = f.accent;
            return (
              <article
                key={f.key}
                data-testid={`formule-card-${f.key}`}
                className={`reveal reveal-delay-${idx + 1} card-lift relative rounded-3xl p-7 sm:p-8 lg:p-10 flex flex-col border ${
                  isAccent
                    ? "bg-[#0B3A5B] border-[#0B3A5B] text-white shadow-[0_30px_60px_-20px_rgba(11,58,91,0.45)]"
                    : "bg-white border-[#0B3A5B]/10 text-[#2F3438] shadow-[0_18px_40px_-22px_rgba(11,58,91,0.20)]"
                }`}
              >
                {isAccent && (
                  <div className="absolute -top-3 left-8 inline-flex items-center px-3 py-1 rounded-full bg-[#1E88C8] text-white text-xs font-semibold uppercase tracking-wider">
                    Le plus complet
                  </div>
                )}

                <div className="flex items-center justify-between gap-4">
                  <h3
                    className={`font-display text-xl ${
                      isAccent ? "text-white" : "text-[#0B3A5B]"
                    }`}
                  >
                    {f.name}
                  </h3>
                  <div
                    className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full ${
                      isAccent
                        ? "bg-white/10 text-white/90"
                        : "bg-[#F3F5F7] text-[#2F3438]/70"
                    }`}
                  >
                    <Clock className="h-3 w-3" />
                    {f.duration}
                  </div>
                </div>

                <div className="mt-6 flex items-baseline gap-2">
                  <span
                    className={`font-display text-5xl ${
                      isAccent ? "text-white" : "text-[#0B3A5B]"
                    }`}
                  >
                    {f.price}
                  </span>
                  <span
                    className={`text-sm ${
                      isAccent ? "text-white/70" : "text-[#2F3438]/60"
                    }`}
                  >
                    / prestation
                  </span>
                </div>

                <ul className="mt-8 space-y-3.5 flex-1">
                  {f.items.map((it, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-sm leading-relaxed">
                      <span
                        className={`mt-0.5 flex items-center justify-center h-5 w-5 rounded-full shrink-0 ${
                          isAccent ? "bg-[#1E88C8]" : "bg-[#1E88C8]/10"
                        }`}
                      >
                        <Check
                          className={`h-3 w-3 ${isAccent ? "text-white" : "text-[#1E88C8]"}`}
                          strokeWidth={3}
                        />
                      </span>
                      <span className={isAccent ? "text-white/90" : "text-[#2F3438]/85"}>
                        {it}
                      </span>
                    </li>
                  ))}
                </ul>

                <Button
                  data-testid={`book-button-${f.key}`}
                  onClick={() => onBookFormule(f.key)}
                  className={`btn-press mt-10 h-12 rounded-full font-semibold ${
                    isAccent
                      ? "bg-white text-[#0B3A5B] hover:bg-white/90 hover:scale-[1.02]"
                      : "bg-[#1E88C8] hover:bg-[#1670a8] hover:scale-[1.02] text-white"
                  }`}
                >
                  <CalendarCheck className="h-4 w-4 mr-2" />
                  Prendre rendez-vous
                </Button>
              </article>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-[#2F3438]/60">
          Paiement à la prestation · Déplacement inclus dans les Côtes-d&apos;Armor
        </p>
      </div>
    </section>
  );
}
